export const DOMAIN_SUGGESTIONS = '@usf/domainSuggestions';
